<template>
    <div class="container loading-content" id="LoadingContent">
        <div class="error-template">
            Wait.. While we are collecting data for you...
        </div>
    </div>
</template>
<script>

    export default {
        name:"LoadingContent",
    }
</script>


// WEBPACK FOOTER //
// src/components/LoadingContent.vue